module.exports = __webpack_public_path__ + "static/media/triple-standard-img3.f3f03549.jpg";